/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/**
 *
 * Paytm
 *
 */

import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import {
  ConfirmModal,
  Toggle,
  Conditional,
  Text,
  Space,
} from '@cashfree-intl/coherent';
import { getIcon } from 'payments-icons-library';

import { SUCCESS } from 'utils/constants';

import CustomIcons from 'components/CustomIcons';
import Analytics from 'utils/analytics';
import EVENTS from 'constants/analytics';
import {
  COMPLETED,
  CONNECT_PAYTM_ACCOUNT_SUCCESS,
  PAYTM_REPORT_GENERATED,
  CONFIRM_PAYTM_MODAL,
  PAYTM_MODAL,
  ERROR_CONFIG,
  PAYTM_DOC_LINK,
  ACTIVATION_FAILED,
} from '../../constants';

import PaytmModal from './PaytmModal';
import { StyledPaymentMethodIcon, StyledPaytmCard } from '../styled';
import PaytmReportGenerated from './PaytmReportGenerated';
import ConnectPaytmAccountSuccess from './ConnectPaytmAccountSuccess';
import ActivationFailed from './ActivationFailed';
import { getDescriptionByStage } from '../utils';

function Paytm(props) {
  const {
    data,
    // loading,
    getPaytmTestConfig,
    getPageData,
    getPaytmCheckSumHash,
    addPaytmProdConfig,
    addPaytmTestConfig,
    showToast,
    isTest,
    tdr,
    accountStatus,
  } = props;

  const { paytmProdConfig, paytmTestConfig } = data;

  const isActive = accountStatus === 'ACTIVE';

  const { stage } = paytmTestConfig;

  const [modalName, resetModalName] = useState('');
  const [modalData, resetModalData] = useState(null);
  const [testLoader, resetTestLoader] = useState(false);
  const [showPaytmForm, resetShowPaytmForm] = useState(true);
  const [isEditMode, resetEditMode] = useState(false);
  const [expand, setExpand] = useState(false);

  useEffect(() => {
    const handleMessageEvent = event => {
      if (/^react-devtools/gi.test(event.data.source)) return;
      // adding this to debug the issue os paytm activation failed popup showing up on initial render

      if (
        event.origin === window.location.origin &&
        'status' in event.data &&
        'msg' in event.data
      ) {
        if (event.data.status === SUCCESS && stage === COMPLETED) {
          getPageData();
          setTimeout(
            () =>
              showToast({
                message: 'Paytm activated successfully',
                type: 'SUCCESS',
              }),
            100,
          );
        } else if (event.data.status === SUCCESS && stage !== COMPLETED)
          getPaytmTestConfig();
        else if (event.data.status === ERROR_CONFIG && stage === COMPLETED) {
          resetShowPaytmForm(true);
          setTimeout(() => {
            resetModalData({ message: event.data.msg });
            resetModalName(ACTIVATION_FAILED);
          }, 100);
        } else if (event.data.status === ERROR_CONFIG && stage !== COMPLETED) {
          resetEditMode(true);
          resetShowPaytmForm(true);
          setTimeout(() => {
            resetModalData({ message: event.data.msg });
            resetModalName(ACTIVATION_FAILED);
          }, 100);
        } else
          setTimeout(() => {
            resetModalData({ message: event.data.msg });
            resetModalName(ACTIVATION_FAILED);
          }, 100);

        resetTestLoader(false);
      }
    };

    window.addEventListener('message', handleMessageEvent, false);

    if (
      !isEmpty(paytmTestConfig) &&
      (isEmpty(paytmProdConfig) ||
        (!isEmpty(paytmProdConfig) && stage !== COMPLETED))
    )
      setExpand(true);

    return () =>
      window.removeEventListener('message', handleMessageEvent, false);
  }, [paytmTestConfig, paytmProdConfig]);

  const closeModal = () => {
    resetTestLoader(false);
    resetModalName('');
    resetModalData(null);
  };

  const connectAccount = () => {
    if (
      stage !== COMPLETED ||
      (stage === COMPLETED && !isEmpty(paytmProdConfig))
    )
      resetShowPaytmForm(false);
    else resetShowPaytmForm(true);
    resetModalName(PAYTM_MODAL);
  };

  const renderStage = () => (
    <Conditional if={!isEmpty(paytmTestConfig)}>
      <Space className="mt-2" alignItems="center">
        <Space alignItems="center" className="stage success">
          <CustomIcons componentName="GREEN_TICK_SMALL" />
          <Text variant="b12" color="bodyLight">
            Test API Credentials
          </Text>
        </Space>
        <div className="stage-line">
          <CustomIcons
            componentName={stage === COMPLETED ? 'LINE' : 'DOTTED_LINE'}
          />
        </div>
        <Space
          alignItems="center"
          className={`stage ${stage === COMPLETED ? 'success' : 'disabled'}`}
        >
          <CustomIcons
            componentName="GREEN_TICK_SMALL"
            fill={stage !== COMPLETED ? 'var(--SECONDARY_LIGHTER)' : ''}
          />
          <Text
            variant="b12"
            color={stage === COMPLETED ? 'bodyLight' : 'placeholder'}
          >
            Test Transactions
          </Text>
        </Space>
        <div className="stage-line">
          <CustomIcons
            componentName={
              stage === COMPLETED && !isEmpty(paytmProdConfig)
                ? 'LINE'
                : 'DOTTED_LINE'
            }
          />
        </div>
        <Space
          alignItems="center"
          className={`stage ${
            stage === COMPLETED && !isEmpty(paytmProdConfig)
              ? 'success'
              : 'disabled'
          }`}
        >
          <CustomIcons
            componentName="GREEN_TICK_SMALL"
            fill={
              stage !== COMPLETED || isEmpty(paytmProdConfig)
                ? 'var(--SECONDARY_LIGHTER)'
                : ''
            }
          />
          <Text
            variant="b12"
            color={
              stage === COMPLETED && !isEmpty(paytmProdConfig)
                ? 'bodyLight'
                : 'placeholder'
            }
          >
            Prod API Credentials
          </Text>
        </Space>
        <div className="stage-line">
          <CustomIcons componentName="DOTTED_LINE" />
        </div>
        <Space alignItems="center" className="stage disabled">
          <CustomIcons
            componentName="GREEN_TICK_SMALL"
            fill="var(--SECONDARY_LIGHTER)"
          />
          <Text variant="b12" color="placeholder">
            Test Transactions in Prod
          </Text>
        </Space>
      </Space>
    </Conditional>
  );

  const onChevronClick = () => setExpand(!expand);

  const onToggle = () => {
    if (isEmpty(paytmTestConfig)) {
      resetModalName(CONFIRM_PAYTM_MODAL);
    } else {
      connectAccount();
    }
    Analytics.track(EVENTS.PAYMENT_METHODS.CONNECT_PAYTM);
  };

  const icon = getIcon('paytm', 'svg');

  return (
    <StyledPaytmCard>
      <Space
        alignItems="center"
        justifyContent="space-between"
        className={`payment-mode ${expand ? 'mb-3' : ''}`}
      >
        <Space alignItems="center" gap={2} className="display-text-section">
          <StyledPaymentMethodIcon
            src={icon.icon_url}
            className={icon.icon_name}
          />
          <Text color="bodyLight">Paytm</Text>
        </Space>
        <div />
        <Space alignItems="center">
          <Conditional if={isActive}>
            <Text
              className={`${isTest ? '' : 'mr-3'} fit-content`}
              color="success"
            >
              Active
            </Text>
          </Conditional>
          <Conditional if={!isActive && !isEmpty(paytmTestConfig)}>
            <Text className="mr-3 fit-content" color="warning">
              Pending
            </Text>
          </Conditional>
          <Conditional if={!isTest}>
            <div data-testid="toggle">
              <Toggle
                disabled={isActive}
                active={isActive}
                onToggle={onToggle}
              />
            </div>
          </Conditional>
          <Conditional
            if={
              !isEmpty(paytmTestConfig) &&
              (isEmpty(paytmProdConfig) ||
                (!isEmpty(paytmProdConfig) && !isActive))
            }
          >
            <div
              className="ml-7 pointer pl-1"
              onClick={onChevronClick}
              data-event-name="Form_Paytm_Icon_Expand"
              data-ignore-inner-text="true"
            >
              <CustomIcons
                componentName="CHEVRONDOWN"
                direction={expand ? 'up' : 'down'}
              />
            </div>
          </Conditional>
        </Space>
      </Space>
      {/* Expand Items */}
      <Conditional if={expand}>
        <Conditional if={!isActive}>
          <Text color="bodyLight">{getDescriptionByStage(stage)}</Text>
          {renderStage()}
        </Conditional>
        {/* <Conditional if={isActive}>{renderActiveCardContent()}</Conditional> */}
      </Conditional>

      <Conditional if={modalName === PAYTM_MODAL}>
        <PaytmModal
          data={{ paytmTestConfig, paytmProdConfig }}
          getPaytmCheckSumHash={getPaytmCheckSumHash}
          addPaytmTestConfig={addPaytmTestConfig}
          addPaytmProdConfig={addPaytmProdConfig}
          isEditMode={isEditMode}
          resetEditMode={resetEditMode}
          openModal={resetModalName}
          closeModal={closeModal}
          testLoader={testLoader}
          resetTestLoader={resetTestLoader}
          showPaytmForm={showPaytmForm}
          resetShowPaytmForm={resetShowPaytmForm}
          accountStatus={accountStatus}
        />
      </Conditional>
      <Conditional if={modalName === PAYTM_REPORT_GENERATED}>
        <PaytmReportGenerated closeModal={closeModal} />
      </Conditional>
      <Conditional if={modalName === CONNECT_PAYTM_ACCOUNT_SUCCESS}>
        <ConnectPaytmAccountSuccess closeModal={closeModal} />
      </Conditional>
      <Conditional if={modalName === CONFIRM_PAYTM_MODAL}>
        <ConfirmModal
          title="Enable Paytm"
          confirmText="Confirm"
          onClose={closeModal}
          onConfirm={() => resetModalName(PAYTM_MODAL)}
          confirmBtnEvent="Primary_Button_Enable_Paytm_Confirm"
          closeBtnEvent="Link_Button_Enable_Paytm_Cancel"
          closeCrossEvent="Enable_Paytm_Icon_Close"
        >
          To enable Paytm payment method you need to connect your Paytm business
          account with Cashfree Payments. Refer for detailed steps{' '}
          <a href={PAYTM_DOC_LINK} target="_blank" data-event-name="Link_Here">
            here
          </a>
          . A standard pricing of {tdr} % is applicable per transaction.
        </ConfirmModal>
      </Conditional>
      <Conditional if={modalName === ACTIVATION_FAILED}>
        <ActivationFailed closeModal={closeModal} modalData={modalData} />
      </Conditional>
    </StyledPaytmCard>
  );
}

Paytm.propTypes = {
  data: PropTypes.object.isRequired,
  getPaytmTestConfig: PropTypes.func.isRequired,
  getPageData: PropTypes.func.isRequired,
  getPaytmCheckSumHash: PropTypes.func.isRequired,
  addPaytmProdConfig: PropTypes.func.isRequired,
  addPaytmTestConfig: PropTypes.func.isRequired,
  // openConfirmModal: PropTypes.func.isRequired,
  // loading: PropTypes.bool.isRequired,
  showToast: PropTypes.func.isRequired,
  accountStatus: PropTypes.string.isRequired,
  isTest: PropTypes.bool.isRequired,
  tdr: PropTypes.number.isRequired,
  //   disablePaymentMethod: PropTypes.bool.isRequired,
};

export default memo(Paytm);
